import { useState } from 'react';
import api from '../api/axios';

/**
 * Custom hook for managing password change functionality
 */
export const usePasswordManagement = (user, setToast, t) => {
    const [showPasswordChangeModal, setShowPasswordChangeModal] = useState(false);
    const [passwordForm, setPasswordForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
    const [passwordError, setPasswordError] = useState('');

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordForm(prev => ({ ...prev, [name]: value }));
        setPasswordError('');
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setPasswordError('');

        // Validation
        if (passwordForm.newPassword.length < 6) {
            setPasswordError(t('passwordTooShort'));
            return;
        }

        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            setPasswordError(t('passwordMismatch'));
            return;
        }

        if (passwordForm.oldPassword === passwordForm.newPassword) {
            setPasswordError(t('passwordSameAsOld'));
            return;
        }

        try {
            await api.put('/change-password', {
                old_password: passwordForm.oldPassword,
                new_password: passwordForm.newPassword
            });

            // Password changed successfully
            setToast({
                isVisible: true,
                message: t('passwordChanged'),
                type: 'success'
            });
            setShowPasswordChangeModal(false);
            setPasswordForm({ oldPassword: '', newPassword: '', confirmPassword: '' });

            // Update user state to remove must_change_password flag
            if (user) {
                user.must_change_password = false;
            }
        } catch (err) {
            console.error('Failed to change password:', err);
            if (err.response?.data?.detail === 'Incorrect current password') {
                setPasswordError(t('incorrectCurrentPassword'));
            } else if (err.response?.data?.detail === 'New password must be different from current password') {
                setPasswordError(t('passwordSameAsOld'));
            } else {
                setPasswordError(t('passwordChangeError'));
            }
        }
    };

    return {
        showPasswordChangeModal,
        setShowPasswordChangeModal,
        passwordForm,
        passwordError,
        handlePasswordChange,
        handlePasswordSubmit
    };
};
